import OperatorActionTypes from './types';

export const fetchOperatorOnBoardingPageActive = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_ACTIVE_SCREEN,
  payload: payload,
});
export const fetchOperatorIsYourVehicle = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_IS_YOUR_VEHICLE,
  payload: payload,
});
export const fetchOperatorVehicleBodyType = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_BODYTYPE,
  payload: payload,
});
// export const fetchOperatorVehicleTyre = (payload: any) => ({
//   type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE,
//   payload: payload,
// });
export const fetchOperatorVehicleTun = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TUN,
  payload: payload,
});
// export const fetchOperatorVehicleHeight = (payload: any) => ({
//   type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_HEIGHT,
//   payload: payload,
// });
export const fetchOperatorVehicleSize = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SIZE,
  payload: payload,
});
export const fetchOperatorVehicleFrontRc = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_FRONT_RC,
  payload: payload,
});
export const fetchOperatorVehicleBackRc = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_BACK_RC,
  payload: payload,
});

export const fetchOperatorVehicleSelectedNumber = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_NUMBER,
  payload: payload,
});

export const fetchOperatorVehicleSelectedSize = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_SIZE,
  payload: payload,
});
export const fetchOperatorVehicleSelectedTyre = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_TYRE,
  payload: payload,
});
export const fetchOperatorVehicleSelectedTun = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_TUN,
  payload: payload,
});
export const fetchOperatorVehicleSelectedHeight = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_HEIGHT,
  payload: payload,
});
export const fetchOperatorVehicleSelectedBody = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_SELECTED_BODY,
  payload: payload,
});

export const fetchOperatorVehicleListingStart = () => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_LISTING_START,
});
export const fetchOperatorListingSuccess = (data: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_LISTING_SUCCESS,
  payload: data,
});
export const alterOperatorVehicleListData = (data: any) => ({
  type: OperatorActionTypes.ALTER_OPERATOR_LISTING,
  payload: data,
});
export const fetchOperatorListingFailure = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_LISTING_FAILURE,
  payload,
});

export const fetchOperatorVehicleTyreStart = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_START,
  payload: payload,
});

export const fetchOperatorVehicleTyreSuccess = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_SUCCESS,
  payload: payload,
});

export const fetchOperatorVehicleTyreFailure = (payload: any) => ({
  type: OperatorActionTypes.FETCH_OPERATOR_VEHICLE_TYRE_LISTING_FAILURE,
  payload: payload,
});

export const postUploadDocStart = (payload: any, typeImg: any, imgSide: any) => ({
  type: OperatorActionTypes.POST_UPLOAD_DOC_START,
  // params,
  payload,
  typeImg,
  imgSide,
});

export const postUploadDocSuccess = (params: any, payload: any) => ({
  type: OperatorActionTypes.POST_UPLOAD_DOC_SUCCESS,
  params,
  payload,
});

export const getUploadedImagesStart = (payload: any, typeImg: any) => ({
  type: OperatorActionTypes.GET_UPLOADED_IMAGES_START,
  payload,
  typeImg,
});
export const getUploadedImagesSuccess = (payload: any) => ({
  type: OperatorActionTypes.GET_UPLOADED_IMAGES_SUCCESS,
  payload,
});
export const getUploadedImagesFailure = (payload: any) => ({
  type: OperatorActionTypes.GET_UPLOADED_IMAGES_FAILURE,
  payload,
});

export const getUploadedImagesRcBackStart = (payload: any, typeImg: any) => ({
  type: OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_START,
  payload,
  typeImg,
});
export const getUploadedImagesRcBackSuccess = (payload: any) => ({
  type: OperatorActionTypes.GET_UPLOADED_RC_BACK_IMAGES_SUCCESS,
  payload,
});

export const postVehicleDataUpdateStart = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_START,
  payload,
});

export const postVehicleDataUpdateSuccess = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_SUCCESS,
  payload,
});
export const postVehicleDataUpdatefailure = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_FAILURE,
  payload,
});
export const updateVehicleDataStart = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_START_V2,
  payload,
});

export const updateVehicleDataSuccess = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_SUCCESS_V2,
  payload,
});
export const updatevehicleDataFailure = (payload: any) => ({
  type: OperatorActionTypes.POST_VEHICLE_DATA_UPDATE_FAILURE_V2,
  payload,
});

export const rcFrontResKey = (payload: any) => ({
  type: OperatorActionTypes.GET_RESOURCE_KEY_RC_FRONT,
  payload,
});

export const rcBackResKey = (payload: any) => ({
  type: OperatorActionTypes.GET_RESOURCE_KEY_RC_BACK,
  payload,
});

export const updateVehicleSuccess = (payload: any) => ({
  type: OperatorActionTypes.UPDATE_VEHICLE_SUCCESS,
  payload,
});

// operator actiona start from here

export const operatorDocListStart = () => ({
  type: OperatorActionTypes.OPERATOR_DOC_LIST_START,
  // payload,
});
export const operatorDocListSuccess = (payload: any) => ({
  type: OperatorActionTypes.OPERATOR_DOC_LIST_SUCCESS,
  payload,
});
export const operatorDocListFailure = (payload: any) => ({
  type: OperatorActionTypes.OPERATOR_DOC_LIST_FAILURE,
  payload,
});

export const adharFrontResKey = (payload: any) => ({
  type: OperatorActionTypes.GET_RESOURCE_KEY_AAADHAR_FRONT,
  payload,
});

export const adharBackResKey = (payload: any) => ({
  type: OperatorActionTypes.GET_RESOURCE_KEY_AAADHAR_BACK,
  payload,
});

export const OperatorgetUploadedImagesStart = (payload: any, typeImg: any) => ({
  type: OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_START,
  payload,
  typeImg,
});
export const OperatorGetUploadedImagesSuccess = (payload: any) => ({
  type: OperatorActionTypes.OPERATOR_GET_UPLOADED_IMAGES_SUCCESS,
  payload,
});
export const OperatorGetUploadedBackImagesSuccess = (payload: any) => ({
  type: OperatorActionTypes.OPERATOR_GET_UPLOADED_BACK_IMAGES_SUCCESS,
  payload,
});

export const OperatorPostUploadDocStart = (payload: any, typeImg: any, imgSide: any) => ({
  type: OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_START,
  // params,
  payload,
  typeImg,
  imgSide,
});

export const OperatorPostUploadDocSuccess = (params: any, payload: any) => ({
  type: OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_SUCCESS,
  params,
  payload,
});
export const OperatorPostUploadDocFailure = (params: any, payload: any) => ({
  type: OperatorActionTypes.OPERATOR_POST_UPLOAD_DOC_FAILURE,
  params,
  payload,
});

export const OperatorPostUploadDocSubmitStart = (payload: any) => ({
  type: OperatorActionTypes.POST_OPERATOR_DATA_UPDATE_START,
  // params,
  payload,
});

export const OperatorPostUploadDocSubmitSuccess = (payload: any) => ({
  type: OperatorActionTypes.POST_OPERATOR_DATA_UPDATE_SUCCESS,
  // params,
  payload,
});
export const fetchGPSImageUrlsStart = () => ({
  type: OperatorActionTypes.FETCH_GPS_IMAGE_URLS,
});
export const fetchGPSImageUrlsSuccess = (payload: any) => ({
  type: OperatorActionTypes.FETCH_GPS_IMAGE_URLS_SUCCESS,
  payload,
});
export const fetchGPSImageUrlsFailure = () => ({
  type: OperatorActionTypes.FETCH_GPS_IMAGE_URLS_FAILURE,
});
export const gpsOrderRequest = (payload: any) => ({
  type: OperatorActionTypes.GPS_ORDER_REQUEST,
  payload,
});
export const gpsOrderRequestSuccess = (payload: any) => ({
  type: OperatorActionTypes.GPS_ORDER_REQUEST_SUCCESS,
  payload,
});
export const gpsOrderRequestFailure = () => ({
  type: OperatorActionTypes.GPS_ORDER_REQUEST_FAILURE,
});

export const fetchGpsVariant = () => ({
  type: OperatorActionTypes.FETCH_GPS_VARIANT,
});
export const fetchGpsVariantSuccess = (payload: any) => ({
  type: OperatorActionTypes.FETCH_GPS_VARIANT_SUCCESS,
  payload,
});
export const fetchGpsVariantFailure = () => ({
  type: OperatorActionTypes.FETCH_GPS_VARIANT_FAILURE,
});

export const uploadDocuments = (payload: any) => ({
  type: OperatorActionTypes.UPLOAD_DOCUMENT,
  payload,
});
export const uploadDocumentsSuccess = (payload: any) => ({
  type: OperatorActionTypes.UPLOAD_DOCUMENT_SUCCESS,
  payload,
});
export const uploadDocumentsFailure = () => ({
  type: OperatorActionTypes.UPLOAD_DOCUMENT_FAILURE,
});
export const uploadDocumentsReset = () => ({
  type: OperatorActionTypes.CLEAR_DOCUMENTS,
});
export const clearDocument = (payload: any) => ({
  type: OperatorActionTypes.CLEAR_DOCUMENT,
  payload,
});

export const fetchVehicleReqData = (payload: any) => ({
  type: OperatorActionTypes.FETCH_VEH_REQ_DATA,
  payload,
});
export const fetchVehicleReqDataSuccess = (payload: any) => ({
  type: OperatorActionTypes.FETCH_VEH_REQ_DATA_SUCCESS,
  payload,
});
export const fetchVehicleReqDataFailure = () => ({
  type: OperatorActionTypes.FETCH_VEH_REQ_DATA_FAILURE,
});

export const setVehicleFormData = (payload: any) => ({
  type: OperatorActionTypes.SET_VEHICLE_FORM_DATA,
  payload,
});
